import {
	AgeCategoryEnum,
	ClubHouseType,
	ColorEnum,
	GameAnalysisStatusEnum,
	GenderEnum,
	PositionEnum,
} from "libs/apiClient";

export const AllGenderOptions = (Object.keys(GenderEnum.Values) as Array<keyof typeof GenderEnum>).map((key) => ({
	label: key,
	value: key,
}));

export const GenderOptions = (Object.keys(GenderEnum.Values) as Array<keyof typeof GenderEnum>).filter((key) => key as string !== "Mixed").map((key) => ({
	label: key,
	value: key,
}));

export const ColorOptions = (Object.keys(ColorEnum.Values) as Array<keyof typeof ColorEnum>).map((key) => ({
	label: key,
	value: key,
}));

export const AgeCategoryOptions = (Object.keys(AgeCategoryEnum.Values) as Array<keyof typeof AgeCategoryEnum>).map((key) => ({
	label: key,
	value: key,
}));

export const ClubHouseTypeChoices = (Object.keys(ClubHouseType.Values) as Array<keyof typeof ClubHouseType>).map((key) => ({
	label: key,
	value: key,
}));

export const PositionChoices = (Object.keys(PositionEnum.Values) as Array<keyof typeof PositionEnum>).map((key) => ({
	label: key,
	value: key,
}));

export const GameAnalysisStatusEnumChoices = (Object.keys(GameAnalysisStatusEnum.Values) as Array<keyof typeof GameAnalysisStatusEnum>).map((key) => ({
	label: key,
	value: key,
}));

export const BooleanChoices = [{
	label: "Yes",
	value: "true",
}, {
	label: "No",
	value: "false",
}];

export const FootChoices = [{
	label: "Left",
	value: "left",
}, {
	label: "Right",
	value: "right",
}];

export const DiscoverRoleChoices = [{
	label: 'Coach',
	value: 'ROLE_DISCOVER_COACH',
}, {
	label: 'Player',
	value: 'ROLE_DISCOVER_PLAYER',
}, {
	label: 'Parent',
	value: 'ROLE_DISCOVER_PARENT',
}, {
	label: 'Works for a club',
	value: 'ROLE_DISCOVER_WORKS_FOR_CLUB',
}];
